export default __webpack_public_path__ + "static/media/pngwing2.4e6febb4.png";